import { type SnippetModalState } from '@/components/modal/snippet-editor-modal-atoms';
import { type Editor } from '@tiptap/react';

/**
 * Editor-agnostic text-menu selection commands shared by every editor twin
 * (v1, vJSON, vMarkdown, markdown-native). They only read the selection and
 * hand off to a session-level modal, so there is nothing editor-specific to
 * fork — keeping one implementation here is what stops the menus drifting.
 */

/** Seed the find & replace modal with the selected text; no-op when empty. */
export const seedFindReplaceFromSelection = (
  editor: Editor,
  onFindReplaceClick: (text: string) => void
): void => {
  const selectedText = editor.state.doc.textBetween(
    editor.state.selection.from,
    editor.state.selection.to
  );
  if (!selectedText) {
    return;
  }
  onFindReplaceClick(selectedText);
};

/** Open the snippet editor pre-filled with the selected text; no-op when empty. */
export const openSnippetFromSelection = (
  editor: Editor,
  openSnippetModal: (state: SnippetModalState) => void
): void => {
  const selectedText = editor.state.doc.textBetween(
    editor.state.selection.from,
    editor.state.selection.to,
    '\n', // block separator
    '\n' // leaf separator
  );
  if (!selectedText) {
    return;
  }
  openSnippetModal({
    open: true,
    from: 'editor',
    isEditing: false,
    initialSnippet: { shorthand: '', content: selectedText },
  });
};
